export const CUSTOMER_LOYALTY_EVENTS = {
  GET_CUSTOMER_EVENTS: '/customer-events',
  GET_CUSTOMER_EVENTS_FILTERS: '/customer-events/filters',
  SHOW_INTEREST_POST: '/customer-events/:uuid/show-interest'
};

export const BOOKING_PROCESS = {
  GET_SESSIONS_FOR_EVENTS: '/customer-events/:eventId/sessions',
  POST: '/bookings',
  GET_AVAILABLE_SEATS: '/events/:eventId/available-seats',
  GET_FORM_RESOURCES:
    'localization-types?types=Gender&types=Title&types=Country&types=NativeLanguage&types=Allergy&types=IndustrySector&types=AcademicTitle',
  GET_REGIONS: '/addresses/countries/:id/regions',
  GET_CANCELLATION_REASONS: 'localization-types?types=ParticipantCancellationReason',
  DECLINE_INVITATION: '/customer-events/participants/:uuid/cancel',
  BOOKINGS_CONFIRMATION: 'bookings/:uuid',
  PARTICIPANT_CONFIRMATION: 'participants/uuid/:uuid'
};

export const CONSENT = {
  GET_ALL_CONSENTS: '/consents'
};

export const EVENT_DETAILS = {
  GET_EVENT_DETAILS: '/customer-events/:eventUuid',
  GET_BILLING_DATA: '/customer-events/:eventId/bookings/:bookingUuid',
  GET_PARTICIPANT_DATA: '/customer-events/:eventUuid/bookings/:bookingUuid/participants'
};
export const SEARCH_DELAY_TIME = 700;
